import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { FlowPromptResponse } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function deleteFlowPrompt(
  promptId: string,
  type: "flow_personal" | "flow_company" = "flow_personal"
): Promise<void> {
  return api.delete(`/explorer/flow-prompt/${promptId}?type=${type}`)
}

export function useDeleteFlowPrompt() {
  const queryClient = useQueryClient()

  const deleteFlowPromptMutation = useMutation({
    mutationKey: queryKeys.deleteFlowPrompt,
    mutationFn: ({
      promptId,
      type,
    }: {
      promptId: string
      type: "flow_personal" | "flow_company"
    }) => deleteFlowPrompt(promptId, type),
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<FlowPromptResponse>(queryKeys.flowPrompts, (current) => {
        if (!current?.prompts) return current
        return {
          prompts: current.prompts.filter((prompt) => prompt.id !== variables.promptId),
        }
      })
    },
  })

  return deleteFlowPromptMutation
}
